import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Community } from '@models/communities/community.model';
import { Media } from '@models/media/media.model';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss'],
})
export class LibraryComponent {
  @Input() community: Community | null = null;
  @Output() emitter: EventEmitter<Media> = new EventEmitter();
}
